export default {
  es: {
    'app.table-list.index.column.actions': 'Acciones',
    'app.table-list.index.btn.edit': 'editar',
    'app.table-list.index.buscar': 'Buscar',
    'app.visitas.index.send': 'correos',
  },
};